function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { ajax, nodeArray, loopObject, containsClass, Event } from 'meteora';
// import Equalizer from './equalizer';
import inView from 'in-view';

// const ajax = require('../functions/ajax');

/** 
* This ES6(ECMAScript) function getQueryStringParameters takes url 
* as parmater and returns
* parameters name and value in JSON key value format 
* @parameter {String} url 
* (if url is not passed it takes the current url 
* from window.location.href) 
* 
**/
var getQueryStringParameters = function getQueryStringParameters(url) {
  var query;
  if (url) {
    if (url.split("?").length > 0) {
      query = url.split("?")[1];
    }
  } else {
    url = window.location.href;
    query = window.location.search.substring(1);
  }
  return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
    var _param$split = param.split('='),
      _param$split2 = _slicedToArray(_param$split, 2),
      key = _param$split2[0],
      value = _param$split2[1];
    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    return params;
  }, {});
};
var Filters = /*#__PURE__*/function () {
  function Filters(container) {
    var _this = this;
    _classCallCheck(this, Filters);
    this.section = container;
    this.contentAreas = nodeArray(this.section.querySelectorAll('.js-filter--content'));
    this.url = this.section.getAttribute('data-filter-link');
    this.lists = nodeArray(this.section.querySelectorAll('.js-filter--list'));
    this.equalizers = nodeArray(this.section.querySelectorAll('.js-filter--content[data-equalize]'));
    this.query = getQueryStringParameters().q;
    this.filters = {};
    this.timeout = null;
    this.lists.forEach(function (list) {
      _this.filters[list.getAttribute('data-filter-name')] = {
        type: list.getAttribute('data-filter-type'),
        value: [],
        controllers: {
          links: nodeArray(list.querySelectorAll('.js-filter--link')),
          select: list.querySelector('.js-filter--select')
        }
      };
    });
    loopObject(this.filters, function (name, settings) {
      settings.controllers.links.forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();

          // Reset the filter value
          settings.value = [];
          settings.urlSegments = [];

          // If we allow for multiple values
          if (settings.type === 'multiple') {
            // Disabling the filter
            if (containsClass(link, 'js-active')) {
              link.classList.remove('js-active');
              link.blur();
            }
            // Enabling the filter
            else {
              link.classList.add('js-active');
            }
          }
          // If it is only a single value
          else {
            settings.controllers.links.forEach(function (l) {
              // Disabling the filter
              if (link !== l) {
                // if (link !== l || containsClass(l, 'js-active')) {
                l.classList.remove('js-active');
              }
              // Enabling the filter
              else {
                l.classList.add('js-active');
              }
            });
          }

          // Get all the active filters
          settings.controllers.links.forEach(function (l) {
            if (containsClass(l, 'js-active')) settings.value.push(l.getAttribute('data-id'));
            if (containsClass(l, 'js-active')) settings.urlSegments.push(l.getAttribute('data-segment'));
          });
          _this.applyFilter();
        });
      });
      settings.controllers.select.addEventListener('change', function (e) {
        e.preventDefault();
        settings.value = [];
        settings.urlSegments = [];

        // If we allow for multiple values
        if (settings.type === 'multiple') {
          // Get all the active filters
          for (var i = 0; i < settings.controllers.select.selectedOptions.length; i++) {
            var item = settings.controllers.select.selectedOptions[i];
            settings.value.push(item.value);
            settings.urlSegments.push(item.getAttribute('data-segment'));
          }
        } else {
          // Get all the active filters
          settings.value.push(settings.controllers.select.value);
          settings.urlSegments.push(settings.controllers.select.selectedOptions[0].getAttribute('data-segment'));
        }
        _this.applyFilter();
      });
    });
  }
  _createClass(Filters, [{
    key: "getDataByIndex",
    value: function getDataByIndex(data, index) {
      var dataArray = [];
      for (var item in data) {
        if (Array.isArray(data[item])) dataArray.push(data[item]);
      }
      ;
      return dataArray[index];
    }
  }, {
    key: "applyFilter",
    value: function applyFilter() {
      var _this2 = this;
      clearTimeout(this.timeout);
      this.contentAreas.forEach(function (area) {
        // Indicates the page is about to load
        area.classList.add('js-waiting');
      });

      // Throttle the requests
      this.timeout = setTimeout(function () {
        _this2.contentAreas.forEach(function (area, index) {
          var i = 0;
          var prefix = '?';
          var url = _this2.url;
          var segmentURL = window.location.origin + window.location.pathname;

          // Indicates the page is loading
          area.classList.remove('js-waiting');
          area.classList.add('js-loading');
          if (_this2.query) {
            url += "".concat(prefix, "q=").concat(_this2.query);
            segmentURL += "".concat(prefix, "q=").concat(_this2.query);
            i += 1;
          }
          ;

          // Generate the URL based on the current filters
          loopObject(_this2.filters, function (name, settings) {
            prefix = i === 0 ? '?' : '&';
            if (settings.value.length) {
              url += "".concat(prefix + name, "=").concat(settings.value.join(','));
              segmentURL += "".concat(prefix + name, "=").concat(settings.urlSegments.join(','));
              i += 1;
            }
            ;
          });

          // Ajax in the results
          ajax({
            url: url,
            method: 'GET',
            success: function success(response) {
              var data = _this2.getDataByIndex(JSON.parse(response).data, index);
              _this2.updateURL(segmentURL);

              // Clear the current content
              area.innerHTML = '';
              if (data.length) {
                data.forEach(function (result) {
                  return area.innerHTML += result.html;
                });
              } else {
                area.innerHTML = '<h5 class="column [ js-filter--error ]">Sorry, there were no results found for that specific search.</h5>';
              }
              if (area.AccordionGrid !== undefined) area.AccordionGrid.update();
              setTimeout(function () {
                // Indicates the page has loaded
                area.classList.remove('js-loading');
                inView('.js-filter--item .js-in-view').on('enter', function (el) {
                  setTimeout(function () {
                    el.classList.add('in-view');
                  }, 500);
                });
                if (_this2.equalizers.length && _this2.equalizers[index]) _this2.equalizers[index].Equalizer.update();
                if (area.Macy !== undefined && area.Macy !== null) area.Macy.reInit();
              }, 500);
            }
          });
        });
      }, 500);
    }
  }, {
    key: "updateURL",
    value: function updateURL(url) {
      window.history.replaceState({}, "filters", url);
    }
  }]);
  return Filters;
}();
export { Filters as default };